import React from 'react';
import '../Styles/ProductReviewscard.css'; 

const ProductReviewsCard = ({name,price,image,index,review}) => {
  return (
    <div className='productCard'>
        <img src={image} alt={`${index} image`}/>
        <h5>{review}</h5>
        <span>{name}</span>
        <b>{price}</b>



    </div>
  )
}

export default ProductReviewsCard